import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

import { NextPanel } from 'src/app/models/next-panel';
import { EnrolmentOnboardModel, OnboardingIntializeCriteria, OnboardingModeSelection, OnboardingEnrollmentsItem } from 'src/app/models/enrollment-onboard';
import { SessionService } from './storage/session.service';

const controllerRoute = '/enrollment-onboarding';

@Injectable()
export class EnrollmentOnboardService {
    
    public adminEventId: number;
    public enrollYearRoundOptionId: number;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService,
    ) {
    }

    public getInitialize(): Observable<NextPanel> {
        if (this.adminEventId || this.enrollYearRoundOptionId) {
            const payload: OnboardingIntializeCriteria = new OnboardingIntializeCriteria;

            if (this.adminEventId)
                payload.memberAdminEventId = this.adminEventId;
            if (this.enrollYearRoundOptionId)
                payload.enrollYearRoundOptionId = this.enrollYearRoundOptionId;

            this.adminEventId = 
                this.enrollYearRoundOptionId = null;
                
            return this.apiService.post(`${controllerRoute}/initialize`, payload).pipe(
                map((response: NextPanel) => {
                    this.sessionService.versionSetGuard(response.version);
                    return response;
                }),
            );
        }
        return this.apiService.get(`${controllerRoute}/initialize`).pipe(
            map((response: NextPanel) => {
                this.sessionService.versionSetGuard(response.version);
                return response;
            }),
        );
    }

    public getMode(): Observable<EnrolmentOnboardModel> {
        return this.apiService.get(`${controllerRoute}/mode`).pipe(
            map((response: EnrolmentOnboardModel) => {
                return response; 
            }),
        );
    }

    // public processMode(payload: OnboardingModeSelection): Observable<NextPanel> {
    //     return this.apiService.post(`${controllerRoute}/mode`, payload).pipe(
    //         map((response: NextPanel) => {
    //             return response;
    //         }),
    //     );
    // }

    // /**
    //  * No data is returned and child component will build the form
    //  * @returns Null;
    //  */
    // public getProfile(): Observable<null> {
    //     return this.apiService.get(`${controllerRoute}/profile`).pipe(
    //         map((response: null) => {
    //             return response;
    //         }),
    //     );
    // }

    // public setProfile(): Observable<NextPanel> {
    //     return this.apiService.post(`${controllerRoute}/profile`, null).pipe(
    //         map((response: NextPanel) => {
    //             return response;
    //         }),
    //     );
    // }

    public autoOnboarding(payload: OnboardingModeSelection): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/auto-onboarding`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

     public autoOnboardingQleBenefitRequest(): Observable<OnboardingEnrollmentsItem> {
            const payload: OnboardingIntializeCriteria = new OnboardingIntializeCriteria;

            if (this.adminEventId)
                payload.memberAdminEventId = this.adminEventId;
            if (this.enrollYearRoundOptionId)
                payload.enrollYearRoundOptionId = this.enrollYearRoundOptionId;

            this.adminEventId = 
                this.enrollYearRoundOptionId = null;

        return this.apiService.post(`${controllerRoute}/auto-onboarding-qle-benefit-request`, payload).pipe(
            map((response: OnboardingEnrollmentsItem) => {
                return response;
            }),
        );
    }

    // public getQualifyingEventSelect(): Observable<NextPanel> {
    //     return this.apiService.get(`${controllerRoute}/qualifying-event/select`).pipe(
    //         map((response: NextPanel) => {
    //             return response;
    //         }),
    //     );
    // }

    // public getQualifyingEventReview(): Observable<NextPanel> {
    //     return this.apiService.get(`${controllerRoute}/qualifying-event/review`).pipe(
    //         map((response: NextPanel) => {
    //             return response;
    //         }),
    //     );
    // }

    // public getFinalize(): Observable<EnrollmentFinalizeResponse> {
    //     return this.apiService.get(`${controllerRoute}/finalize`).pipe(
    //         map((response: EnrollmentFinalizeResponse) => {
    //             return response;
    //         }),
    //     );
    // }

    // public setFinalize(): Observable<null> {
    //     return this.apiService.post(`${controllerRoute}/finalize`, null).pipe(
    //         map((response: null) => {
    //             return response;
    //         }),
    //     );
    // }

    // public resetOnboarding(): Observable<NextPanel> {
    //     return this.apiService.get(`${controllerRoute}/reset-onboarding`).pipe(
    //         map((response: NextPanel) => {
    //             return response;
    //         }),
    //     );
    // }
}